import React from "react";
import classes from "./Title.module.scss";

interface Interface {
  center?: boolean;
  children?: any;
  className?: string;
  full?: boolean;
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  huge?: boolean;
  light?: boolean;
  text?: any;
  little?: boolean;
  isolate?: boolean;
}

const getTitle = (h: string, className = "", children: any) => {
  switch (h) {
    case "1":
      return (
        <h1 data-testid="title-component" className={className}>
          {children}
        </h1>
      );
    case "2":
      return (
        <h2
          data-testid="title-component"
          className={className + " " + classes.T2}
        >
          {children}
        </h2>
      );
    default:
      return (
        <h3
          data-testid="title-component"
          className={className + " " + classes.T3}
        >
          {children}
        </h3>
      );
  }
};

export default function Title({
  center = false,
  children = null,
  className = "",
  full = false,
  h2 = false,
  h3 = false,
  huge = false,
  light = false,
  little = false,
  text = null,
  isolate = false,
}: Interface) {
  let _content = null;
  if (text || children) {
    className += " " + classes.Title;
    if (center) className += " " + classes.Center;
    if (full) className += " " + classes.Full;
    if (huge) className += " " + classes.Huge;
    if (light) className += " " + classes.Light;
    if (little) className += " " + classes.Little;
    if (isolate) className += " " + classes.Isolate;
    _content = getTitle(
      h2 ? "2" : h3 ? "3" : "1",
      className,
      <>
        {text}
        {children}
      </>
    );
  }
  return _content;
}
